/* -------- 
  General functions for small tasks 
  on both pages
-------- */

// convert object to querystring and return
function objectToQS(obj) {
  return new URLSearchParams(obj).toString();
}

// convert querystring to object
function objectFromQS(queryString) {
  const params = new URLSearchParams(queryString);
  const queryObj = {};

  for (const [key, value] of params.entries()) {
    queryObj[key] = value;
  }
  return queryObj;
}

function generatePrint(elem) {
  // var header_str =
  //   "<html><head><title>" + document.title + "</title></head><body>";
  // var footer_str = "</body></html>";
  // var new_str = document.getElementById(elem).innerHTML;
  // var old_str = document.body.innerHTML;
  // document.body.innerHTML = header_str + new_str + footer_str;
  window.print();
  // document.body.innerHTML = old_str;
  return false;
}

function encodeArray(arr) {
  // return JSON.stringify(arr);
  // Convert the array of objects to a JSON string
  const jsonString = JSON.stringify(arr);

  // Encode the JSON string to base64
  return btoa(jsonString);
}

function decodeArray(encodedStr) {
  // return JSON.parse(encodedStr);
  // Decode the base64 string back to a JSON string
  const jsonString = atob(encodedStr);

  // Parse the JSON string back to an array of objects
  return JSON.parse(jsonString);
}

function roundUpToNextTen(num) {
  // Find the number of digits in the number
  let power = Math.pow(10, Math.floor(Math.log10(num)));
  
  // Round the number up to the nearest multiple of the next power of 10
  return Math.ceil(num / power) * power;
}

function getMultiplier(elevation) {
  let multiplier;
  if (elevation <= 500) {
    multiplier = 1;
  } else {
    const extraDistance = elevation - 500;
    const steps = Math.floor(extraDistance / 100);
    multiplier = Math.pow(1.04, steps);
    multiplier = multiplier.toFixed(2);
  }


  return multiplier;
}

const PUB_SUB_RECHNER = {
  global_update: "global_update",
  result_update: "result_update",
};

/* -------- 
  calculations per step, handles calculations 
  and results at step level 
-------- */

class KuhlleistungsrechnerStep {
  constructor(container, root, r_houseType, r_elevation) {
    this.root = root;
    this.step = parseInt(container.dataset.step);
    this.container = container;
    this.roomInput = container.querySelector(".room-name");
    this.sizeInput = container.querySelector(".room-size");
    this.widthInput = container.querySelector(".room-width");
    this.heightInput = container.querySelector(".room-height");
    this.volumeOutput = container.querySelector(".room-volume");
    this.wallsInputs = container.querySelectorAll(
      'input[type="radio"].input-walls'
    );
    this.houseInputs = container.querySelectorAll(
      'input[type="radio"].input-house'
    );
    this.addressInput = container.querySelector(".cform_adresse");
    this.elevationOutput = container.querySelector(".cform_uber_meer");
    this.volumeOutput.disabled = 1;

    this.insulationChart = {
      gut: [16, 20, 24, 28, 32],
      mittel: [16, 28, 32, 36, 40],
      schlecht: [16, 36, 40, 44, 48],
    };
    this.houseType = r_houseType || "";

    this.roomname = "Room " + this.step;
    this.volume = 0;
    this.area = 0;
    this.walls = 0;
    this.insulation = 0;
    this.insulatedVolume = 0;
    this.elevation = r_elevation || 0;

    this.result = {};

    // start!
    this.attachEventListeners();
    this.initAutocomplete();
    this.autoUpdate(r_elevation, r_houseType);
  }

  initAutocomplete() {
    if (!this.addressInput || !this.elevationOutput) return 0;
    this.elevationOutput.disabled = 1;
    // Create the autocomplete object, restricting the search predictions to geographical location types.
    const autocomplete = new google.maps.places.Autocomplete(
      this.addressInput,
      { types: ["geocode"] }
    );

    // When the user selects an address from the drop-down, populate the address fields in the form.
    autocomplete.addListener("place_changed", () => {
      let place = autocomplete.getPlace();
      if (place.geometry) {
        this.getElevation(place.geometry.location);
      }
    });
  }

  getElevation(location) {
    const elevator = new google.maps.ElevationService();
    elevator.getElevationForLocations(
      { locations: [location] },
      (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            this.elevation = parseFloat(results[0].elevation).toFixed(2);
            this.elevationOutput.value = this.elevation;
            this.getResult();
            if (this.step === 1) {
              publish(PUB_SUB_RECHNER.global_update, {
                elevation: this.elevation,
              });
            }
          } else {
            console.log("No elevation data available");
          }
        } else {
          console.log("Elevation service failed due to: " + status);
        }
      }
    );
  }

  attachEventListeners() {
    this.roomInput.addEventListener("input", () => this.getRoomName());
    this.sizeInput.addEventListener("input", () => this.getVolume());
    this.widthInput.addEventListener("input", () => this.getVolume());
    this.heightInput.addEventListener("input", () => this.getVolume());
    this.wallsInputs.forEach((input) => {
      input.addEventListener("change", () =>
        this.updateData("walls", input.value)
      );
    });
    this.houseInputs.forEach((input) => {
      input.addEventListener("change", () => {
        this.updateData("houseType", input.value);
        if (this.step === 1) {
          publish(PUB_SUB_RECHNER.global_update, { houseType: input.value });
        }
      });
    });
  }

  getRoomName() {
    this.roomname = this.roomInput.value.replace("/", "-");
    this.roomInput.value = this.roomname;
    if (this.roomname === "") {
      this.roomname = "Room " + this.step;
    }
    this.getResult();
  }

  getVolume() {
    const size = parseFloat(this.sizeInput.value) || 0;
    const width = parseFloat(this.widthInput.value) || 0;
    const height = parseFloat(this.heightInput.value) || 0;
    this.area = (size * width).toFixed(2);
    this.volume = (size * width * height).toFixed(2);
    this.volumeOutput.value = this.volume;
    // console.log("this.volume", this.volume);
    this.getInsulatedVolume();
  }

  updateData(key, value) {
    this[key] = value;
    this.getInsulation();
  }

  getInsulation() {
    const { walls, houseType } = this;
    this.insulation = houseType ? this.insulationChart[houseType][walls] : 0;
    // console.log("this.insulation", this.insulation);
    this.getInsulatedVolume();
  }

  getInsulatedVolume() {
    this.insulatedVolume = this.volume * this.insulation;
    this.getResult();
  }

  getResult() {
    // console.log("this.step", this.step, this.insulatedVolume);
    if (this.insulatedVolume === 0) return false;
    const {elevation, houseType, roomname, walls, area, volume } = this;

    this.result = {
      id: this.step,
      roomname,
      walls,
      houseType,
      area,
      volume,
      elevation,
    };

    // console.log("this.result", this.step, this.result);
    publish(PUB_SUB_RECHNER.result_update, this.result);
  }

  autoUpdate() {
    if (this.step === 1) return 0;
    subscribe(PUB_SUB_RECHNER.global_update, (e) => {
      Object.keys(e).forEach((key) => {
        this[key] = e[key];
        switch (key) {
          case "houseType":
            this.getInsulation();
            break;

          case "elevation":
            this.getResult();
            break;

          default:
            break;
        }
      });
    });
  }
}

/* -------- 
  calculator as a whole, handles results, 
  new step, remove step, submit 
-------- */

class Kuhlleistungsrechner {
  constructor() {
    this.storecdn =
      "https://testumgebung-ecofort.myshopify.com/cdn/shop/files/";
    this.root = document.querySelector(".Kuhlleistungsrechner-form-wrap");
    this.nextBtn = this.root.querySelector(".next_step_btn");
    this.submitBtn = this.root.querySelector(".submit_btn");
    this.isolationInfo = this.root.querySelector(".isolation-info");
    this.activeRoom = 1;
    this.resultObject = [];

    this.init();
    this.attachEventListeners();
    this.subscribeGlobalInputs();
    this.subscribeResults();
  }

  adaptPlusContent(index) {
    return `<div class="fields_step fields_step_${index}" data-step="${index}">
      <div class="fields_row fields_row_1">
        <div class="close_wrap">
          <div class="close_icon" data-remove="${index}">
            <img
              src="${this.storecdn}close_icon_f4729d01-d7de-44c5-970d-fe7b9063f537.svg"
              alt="" height="auto" width="auto" loading="lazy"
            >
          </div>
        </div>
        <div class="field_room_name">
          <h4 class="field_title"><span class="num">1</span><span class="text">${window.calculator.raumname}:</span></h4>
          <input class="form__input room-name" type="text" value="" required />
          <p>${window.calculator.berechnenden}</p>
        </div>

        <h4 class="field_title"><span class="num">2</span><span class="text">${window.calculator.dimensionen}:</span></h4>
        <p>${window.calculator.raumgrosse}</p>
        <div class="fields_group_wrap">
          <div class="fields_group">
            <label class="form__label"><span class="num">1</span>${window.calculator.raumlange}:</label>
            <input class="form__input room-size" type="text" value="" required />
            <span class="num">m</span>
          </div>

          <div class="fields_group">
            <label class="form__label"><span class="num">2</span>${window.calculator.raumbreite}:</label>
            <input class="form__input room-width" type="text" value="" required />
            <span class="num">m</span>
          </div>

          <div class="fields_group">
            <label class="form__label"><span class="num">3</span>${window.calculator.raumhohe}:</label>
            <input class="form__input room-height" type="text" value="" required />
            <span class="num">m</span>
          </div>

          <span class="fields_equal"> = </span>

          <div class="fields_group">
            <label class="form__label green black_text">m<sup>3</sup></label>
            <input class="form__input green room-volume" type="text" value="" />
          </div>
        </div>
      </div>

      <div class="fields_row fields_row_2">
        
        <h6 class="field_subtitle">
          <span class="num">3</span><span class="text">${window.calculator.aussenwande}:</span>
        </h6>
        <p>${window.calculator.aussenwande_sub}</p>
        <div class="row_2_wrap">
          <div class="fields_group_wrap">
            <div class="fields_group">
              <input type="radio" id="walls_${index}_0" name="walls_${index}" class="input-walls" value="0" required />
              <label class="form__label" for="walls_${index}_0">
                <span class="num">0</span>
                <img src="${this.storecdn}option-1.png" alt="" height="auto" width="auto" loading="lazy" />
              </label>
            </div>
          </div>

          <div class="fields_group_wrap">
            <div class="fields_group">
              <input type="radio" id="walls_${index}_1" name="walls_${index}" class="input-walls" value="1" required />
              <label class="form__label" for="walls_${index}_1">
                <span class="num">1</span>
                <img src="${this.storecdn}option-2.png" alt="" height="auto" width="auto" loading="lazy" />
              </label>
            </div>
          </div>

          <div class="fields_group_wrap">
            <div class="fields_group">
              <input type="radio" id="walls_${index}_2" name="walls_${index}" class="input-walls" value="2" required />
              <label class="form__label" for="walls_${index}_2">
                <span class="num">2</span>
                <img src="${this.storecdn}option-3.png" alt="" height="auto" width="auto" loading="lazy" />
              </label>
            </div>
          </div>

          <div class="fields_group_wrap">
            <div class="fields_group">
              <input type="radio" id="walls_${index}_3" name="walls_${index}" class="input-walls" value="3" required />
              <label class="form__label" for="walls_${index}_3">
                <span class="num">3</span>
                <img src="${this.storecdn}option-4.png" alt="" height="auto" width="auto" loading="lazy" />
              </label>
            </div>
          </div>

          <div class="fields_group_wrap">
            <div class="fields_group">
              <input type="radio" id="walls_${index}_4" name="walls_${index}" class="input-walls" value="4" required />
              <label class="form__label" for="walls_${index}_4">
                <span class="num">4</span>
                <img src="${this.storecdn}option-5.png" alt="" height="auto" width="auto" loading="lazy" />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>`;
  }

  init() {
    this.root.querySelectorAll(".fields_step").forEach((container) => {
      new KuhlleistungsrechnerStep(container, this.root);
    });
  }

  attachEventListeners() {
    this.nextBtn.addEventListener("click", () => {
      this.showNext();
    });

    this.submitBtn.addEventListener("click", () => {
      const qs = encodeArray(this.resultObject);      
      window.location = Shopify.routes.root + "pages/heizleistungs?_ob=" + qs;
    });

    document.addEventListener("click", (e) => {
      if (
        e.target.classList.contains("close_icon") ||
        e.target.closest(".close_icon")
      ) {
        let card = e.target.closest(".fields_step");
        this.removeMe(card.dataset.step);
      }
    });
  }

  removeMe(step) {
    document.querySelector(`.fields_step[data-step="${step}"]`).remove();
    this.removeResults(parseInt(step));
    this.checkCount();
  }

  showNext() {
    this.activeRoom++;
    let html = this.adaptPlusContent(this.activeRoom);
    this.root
      .querySelector(".other_steps")
      .insertAdjacentHTML("beforeend", html);
    let newContainer = this.root.querySelector(
      `.fields_step[data-step="${this.activeRoom}"]`
    );
    const { root, houseType, elevation } = this;
    new KuhlleistungsrechnerStep(newContainer, root, houseType, elevation);
    this.checkCount();
  }

  checkCount() {
    const stepCount = this.root.querySelectorAll(".fields_step").length;
    this.nextBtn.disabled = stepCount >= 7;
    this.isolationInfo.classList.toggle("hidden", stepCount === 1);
  }

  subscribeGlobalInputs() {
    subscribe(PUB_SUB_RECHNER.global_update, (e) => {
      Object.keys(e).forEach((key) => {
        this[key] = e[key];
      });
    });
  }

  subscribeResults() {
    subscribe(PUB_SUB_RECHNER.result_update, (e) => {
      let index = this.resultObject.findIndex((item) => item.id === e.id);
      if (index !== -1) {
        this.resultObject[index] = e;
      } else {
        this.resultObject.push(e);
      }
      // console.log("update", this.resultObject);
      this.checkResults();
    });
  }

  removeResults(i) {
    let index = this.resultObject.findIndex((item) => item.id === i);
    if (index !== -1) {
      this.resultObject.splice(index, 1);
    }
    // console.log("remove", this.resultObject);
    this.checkResults();
  }

  checkResults() {
    this.submitBtn.disabled = this.resultObject.length ? 0 : 1;
  }
}



class HeizleistungsCalculator {
  constructor(outputSelector) {
    this.outputElm = document.querySelector(outputSelector);
    if (!this.outputElm) return;
    this.insulationChart = {
      gut: [16, 20, 24, 28, 32],
      mittel: [16, 28, 32, 36, 40],
      schlecht: [16, 36, 40, 44, 48],
    };
    this.init();
    this.bindEvents();
  }

  // Initialize the process
  async init() {
    const search = new URL(location.href).search;
    const searchObject = objectFromQS(search);
    const searchResDecoded = decodeArray(searchObject["_ob"]);

    searchResDecoded.forEach(async (res, i) => {
      await this.renderOutput(res, i);
    });
  }

  getNewResult (houseType, res) {
    let { walls, volume, elevation } = res;
    let insulation = this.insulationChart[houseType][walls] || 0;
    let insulatedVolume = volume * insulation;

    let multiplier = getMultiplier(elevation);
    const output = (insulatedVolume * multiplier).toFixed(2);
    return output;
  }

  // Render output for each search result
  async renderOutput(res, i) {
    console.log("res", res);
    const res_output = Math.ceil(res.output);

    let newOuput = {
      gut: this.getNewResult("gut", res),
      mittel: this.getNewResult("mittel", res),
      schlecht: this.getNewResult("schlecht", res),
    }

    let op_elevation = res.elevation ? `${Math.ceil(res.elevation)} m` :  "500 m";

    const outputContent = `
      <div data-step="${res.id}">
        <h5>${window.heating_op.room_name}: ${res.roomname}</h5>
        <!-- <h5>${window.heating_op.room_area}: <span>${Math.ceil(res.area)} m<sup>2</sup></span></h5>
        <h5>${window.heating_op.room_volume}: <span>${Math.ceil(res.volume)} m<sup>3</sup></span></h5> -->
        <h5>${window.heating_op.room_area}: <span>${res.area} m<sup>2</sup></span></h5>
        <h5>${window.heating_op.room_volume}: <span>${res.volume} m<sup>3</sup></span></h5>
        <h5>${window.heating_op.room_ext_walls}: <span>${res.walls}</span></h5>
        <h5>${window.heating_op.room_isolation}: <span>${res.houseType}</span></h5>
        <h5>${window.heating_op.room_altitude}: <span>${op_elevation}</span></h5>
      </div>`;

    const outputMain = `
      <h3><strong>${window.heating_op.room_required_power}: ${Math.round((newOuput[res.houseType]))} Watt</strong></h3>
      <p>
        ${window.heating_op.op_good_insulation}: ${Math.round(newOuput.gut)} Watt</br>
        ${window.heating_op.op_med_insulation}: ${Math.round(newOuput.mittel)} Watt</br>
        ${window.heating_op.op_poor_insulation}: ${Math.round(newOuput.schlecht)} Watt
      </p>
      <p>${window.heating_op.op_text}</p>
      <p>${window.heating_op.op_tip}</p>`;

    const nextTen = Math.min(roundUpToNextTen(Math.ceil(res.output)), 2000);
    const filterTag = `attribute_de_Heizleistung_${nextTen} Watt`.replace(" ", "-");
    // const refProducts = await this.fetchProductRecommendations(filterTag);
    const refProducts = "";

    const outerElm = `
      <div class="output op-${i}">
        <div class="output-row">
          <div class="output-main">${outputMain}</div>
          <div class="output-content">${outputContent}</div>
        </div>
        ${refProducts ? `
          <h3>${window.heating_op.our_recommendation}</h3>
          <div class="res-product">
            ${refProducts}
          </div>` : ""
        }
      </div>`;

    this.outputElm.insertAdjacentHTML("beforeend", outerElm);
  }

  // Fetch product recommendations
  async fetchProductRecommendations(filterTag) {
    return await fetch(`${Shopify.routes.root}collections/all/${filterTag}?view=heizleistungs`)
      .then(res => res.text());
  }

  // Event listeners for buttons
  bindEvents() {
    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("pdf-btn")) {
        generatePrint("heizleistungs-page-main");
      }
      if (e.target.classList.contains("email-btn")) {
        this.sendEmail();
      }
    });
  }

  // Send email functionality
  sendEmail() {
    const subject = "ecofort.ch - Heizleistungskalkulation";
    const pageLink = location.href;
    const body = `Wir haben ihr persönliches Resultat zur optimalen Heizleistung kalkuliert:\n\n${pageLink}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (location.href.includes("_ob")) {
    // output page
    new HeizleistungsCalculator(".heizleistungs-output");
  } else {
    // input page
    new Kuhlleistungsrechner();
  }
});
